import React from 'react'
import { useRouter } from 'next/router'

import {
  Sheet,
  SheetCloseButton,
  SheetOverlay,
  SheetContent,
  SheetTitle,
} from '@wartek-id/sheet-v1'
import { List, ListItem } from '@wartek-id/list'
import { Separator } from '@wartek-id/separator'
import { Text } from '@wartek-id/text'

import { useSETrackEventEditProfile } from 'app/ProfileRevampPage/hooks/useSETrackEventEditProfile'

import AccountIcon from 'assets/icons/account.svg'
import EditIcon from 'assets/icons/edit.svg'
import PictureIcon from 'assets/icons/picture.svg'
import LockPersonIcon from 'assets/icons/lock-person.svg'

interface IEditProfilDrawerProps {
  isOpen: boolean
  onClose: () => void
  onCloseButtonClicked: () => void
  onEditPersonalDataClicked: () => void
}

export const EditProfileDrawer = ({
  isOpen,
  onClose,
  onCloseButtonClicked,
  onEditPersonalDataClicked,
}: IEditProfilDrawerProps) => {
  const router = useRouter()
  const { SETrackClickEditProfileDetail } = useSETrackEventEditProfile()

  return (
    <Sheet isOpen={isOpen} onClose={onClose} sheetSize="auto">
      <SheetOverlay />
      <SheetContent className="max-w-xl m-auto !z-[1000]">
        <SheetCloseButton onClick={onCloseButtonClicked} />
        <SheetTitle bold bordered>
          Edit profil
        </SheetTitle>
        <div className="pb-2">
          <List type="menu" bold>
            <ListItem
              className="w-full !px-3 py-2"
              title="edit_photo"
              onClick={() => {
                SETrackClickEditProfileDetail({
                  pageElement: 'PROFILE_PICTURE',
                })
                router.push('/profil/edit/photo')
              }}
            >
              <div className="flex flex-row space-x-3 cursor-pointer">
                <AccountIcon />
                <Text variant="action">Ganti foto profil</Text>
              </div>
            </ListItem>
            <div className="!px-3">
              <Separator orientation="horizontal" />
            </div>
            <ListItem
              className="w-full !px-3 py-2"
              title="edit_cover"
              onClick={() => {
                SETrackClickEditProfileDetail({ pageElement: 'HEADER_PICTURE' })
                router.push('/profil/edit/cover')
              }}
            >
              <div className="flex flex-row space-x-3 cursor-pointer">
                <PictureIcon />
                <Text variant="action">Ganti foto latar</Text>
              </div>
            </ListItem>
            <div className="!px-3">
              <Separator orientation="horizontal" />
            </div>
            <ListItem
              className="w-full !px-3 py-2"
              title="edit_info"
              onClick={() => {
                SETrackClickEditProfileDetail({ pageElement: 'INFO' })
                router.push('/profil/edit/info')
              }}
            >
              <div className="flex flex-row space-x-3 cursor-pointer">
                <EditIcon />
                <Text variant="action">Edit info</Text>
              </div>
            </ListItem>

            <div className="!px-3">
              <Separator orientation="horizontal" />
            </div>
            <ListItem
              className="w-full !px-3 py-2"
              title="edit_personal_data"
              onClick={() => {
                SETrackClickEditProfileDetail({
                  pageElement: 'PERSONAL_DATA',
                })
                onEditPersonalDataClicked()
              }}
            >
              <div className="flex flex-row space-x-3 cursor-pointer">
                <LockPersonIcon />
                <Text variant="action">Edit data pribadi</Text>
              </div>
            </ListItem>
          </List>
        </div>
      </SheetContent>
    </Sheet>
  )
}
